export const HEADERS = [
  {
    text: "Tipo",
    sortable: false,
    value: "type",
    class: "primary white--text",
    rowspan: 2,
    show: true,
    groupable: true
  },
  {
    text: "Fuente",
    sortable: true,
    value: "source",
    class: "primary white--text",
    rowspan: 2,
    show: true
  },
  {
    text: "Campaña",
    value: "campaign",
    class: "primary white--text",
    rowspan: 2,
    show: false
  },
  {
    text: "Segmentación",
    value: "adset",
    class: "primary white--text",
    rowspan: 2,
    show: false
  },
  {
    text: "Anuncio",
    value: "ad",
    class: "primary white--text",
    rowspan: 2,
    show: false
  },
  {
    text: "Formulario",
    value: "form",
    class: "primary white--text",
    rowspan: 2,
    show: false
  },
  {
    text: "Medio",
    value: "medium",
    class: "primary white--text",
    rowspan: 2,
    show: false
  },
  {
    text: "Perfilación",
    value: "category",
    class: "primary white--text",
    rowspan: 2,
    show: false
  },
  {
    text: "Leads",
    sortable: true,
    value: "total",
    class: "primary white--text",
    rowspan: 2,
    show: true
  },
  {
    text: "Activos",
    sortable: false,
    value: "active",
    align: "center",
    subHeaders: [
      {
        text: "TOF",
        value: "tof",
        class: "gradient-active deep-purple--text text--darken-4"
      },
      {
        text: "MOF",
        value: "mof",
        class: "gradient-active deep-purple--text text--darken-4"
      },
      {
        text: "BOF",
        value: "bof",
        class: "gradient-active deep-purple--text text--darken-4"
      }
    ],
    class: "ma-0 px-2 py-4 gradient-active deep-purple--text text--darken-4",
    show: true
  },
  {
    text: "Ventas",
    sortable: true,
    value: "finished",
    align: "center",
    class: "yellow lighten-5 brown--text text--darken-4",
    rowspan: 2,
    show: true
  },
  {
    text: "Descartados",
    sortable: true,
    value: "discarded",
    align: "center",
    class: "grey lighten-2 grey--text text--darken-4",
    rowspan: 2,
    show: true
  }
];

export const ITEM_CLASSES = {
  type: "",
  source: "row-table-color subtitle-2 body-2",
  campaign: "row-table-color body-2",
  adset: "row-table-color body-2",
  ad: "row-table-color body-2",
  form: "row-table-color body-2",
  medium: "row-table-color body-2",
  category: "row-table-color body-2",
  total: "font-weight-bold row-table-color",
  active: "font-weight-bold gradient-active deep-purple--text text--darken-4",
  finished: "font-weight-bold yellow lighten-5 brown--text text--darken-4",
  discarded: "font-weight-bold grey lighten-2 grey--text text--darken-4"
};
